/**
 * @file estadosImages.js
 * @description Static lookup map: Mexican state name → background landmark image path.
 * Keys must match the uppercase state name string returned by the API (estado.nombre).
 * Set a value to null to show no background image for that state.
 * Images live in /public/images/estados/.
 */

const estadosImages = {
  'AGUASCALIENTES':      null,
  'BAJA CALIFORNIA':     null,
  'BAJA CALIFORNIA SUR': null,
  'CAMPECHE':            null,
  'CHIAPAS':             null,
  'CHIHUAHUA':           null,
  'CIUDAD DE MEXICO':    { src: '/images/estados/ciudad-de-mexico.webp', flip: true },
  'CIUDAD DE MÉXICO':    { src: '/images/estados/ciudad-de-mexico.webp', flip: true },
  'COAHUILA':            null,
  'COLIMA':              null,
  'DURANGO':             null,
  'ESTADO DE MEXICO':    { src: '/images/estados/teotihuacan.webp', flip: true },
  'ESTADO DE MÉXICO':    { src: '/images/estados/teotihuacan.webp', flip: true },
  'GUANAJUATO':          null,
  'GUERRERO':            { src: '/images/estados/acapulco.webp', flip: false },
  'HIDALGO':             { src: '/images/estados/prismas-hidalgo.webp', flip: false },
  'JALISCO':             { src: '/images/estados/tequila-jalisco.webp', flip: false },
  'MICHOACAN':           { src: '/images/estados/calzada-morelia.webp', flip: false },
  'MICHOACÁN':           { src: '/images/estados/calzada-morelia.webp', flip: false },
  'MORELOS':             null,
  'NAYARIT':             null,
  'NUEVO LEON':          null,
  'OAXACA':              null,
  'PUEBLA':              { src: '/images/estados/catedral-puebla.webp', flip: false },
  'QUERETARO':           null,
  'QUINTANA ROO':        null,
  'SAN LUIS POTOSI':     null,
  'SINALOA':             null,
  'SONORA':              null,
  'TABASCO':             null,
  'TAMAULIPAS':          null,
  'TLAXCALA':            null,
  'VERACRUZ':            null,
  'YUCATAN':             null,
  'YUCATÁN':             null,
  'ZACATECAS':           null,
};

export default estadosImages;
